var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { DivTag, ImgTag } from '../../Utils/AtomicTag';
import { SuccessImage, ErrorImage, WarningImage, NotFoundImage, ForbiddenImage, ServerErrorImage, } from './DefaultImage';
var SuccessIcon = React.createElement(SuccessImage, null);
var ErrorIcon = React.createElement(ErrorImage, null);
var WarningIcon = React.createElement(WarningImage, null);
var NotFoundIcon = React.createElement(NotFoundImage, null);
var ForbiddenEmptyIcon = React.createElement(ForbiddenImage, null);
var ServerErrorIcon = React.createElement(ServerErrorImage, null);
var statusMap = {
    success: SuccessIcon,
    error: ErrorIcon,
    warning: WarningIcon,
    403: ForbiddenEmptyIcon,
    404: NotFoundIcon,
    500: ServerErrorIcon,
};
var Result = /** @class */ (function (_super) {
    __extends(Result, _super);
    function Result(props) {
        var _this = _super.call(this, props) || this;
        _this.getImage = function (image, status) {
            var imageUrl;
            var defaultImage = SuccessIcon;
            var imgRegx = /^(((https?|ftp|news):\/\/|\w+(\.\w+)+)(:\w+)?).*/;
            if (statusMap[status]) {
                defaultImage = statusMap[status];
            }
            if (typeof image === 'string') {
                image && imgRegx.test(image) && (imageUrl = image);
            }
            return { defaultImage: defaultImage, imageUrl: imageUrl };
        };
        _this.state = {
            defaultImage: SuccessIcon,
        };
        return _this;
    }
    Result.prototype.render = function () {
        var _a = this.props, style = _a.style, image = _a.image, className = _a.className, status = _a.status, children = _a.children, title = _a.title, subTitle = _a.subTitle, extra = _a.extra, rest = __rest(_a, ["style", "image", "className", "status", "children", "title", "subTitle", "extra"]);
        var _b = this.getImage(image, status), defaultImage = _b.defaultImage, imageUrl = _b.imageUrl;
        var wrapCls = ['flex', 'flex-col', 'items-center', 'mx-px-10'];
        var titleCls = [
            'font-semibold',
            'text-current',
            'text-2xl',
            'leading-px-26',
        ];
        var subtitleCls = ['text-sm', 'text-gray-600', 'leading-px-22'];
        var spacingCls = ['pt-px-16'];
        return (React.createElement(DivTag, __assign({ name: Result.NAME, atomics: wrapCls, className: className, style: style }, rest),
            React.createElement(DivTag, { className: 'result-custom-image' }, imageUrl ? React.createElement(ImgTag, { src: imageUrl, alt: "\u56FE\u7247" }) : defaultImage),
            title && React.createElement(DivTag, { atomics: titleCls.concat(spacingCls) }, title),
            subTitle && React.createElement(DivTag, { atomics: subtitleCls.concat(spacingCls) }, subTitle),
            extra && React.createElement(DivTag, { atomics: spacingCls }, extra),
            children));
    };
    Result.defaultProps = defaultProps;
    Result.NAME = 'result';
    Result.displayName = 'Result';
    return Result;
}(PureComponent));
export { Result };
